import { App as AntApp, Upload } from "antd";
import { UploadProps } from "antd/lib/upload/interface";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import AntIcon from "../icons/AntIcon";
import { MultiLineText } from "../views/MultiLineText";
import styles from "./UploadDragger.module.scss";

export const UploadDragger = (props: UploadProps) => {
  const { t } = useTranslation();
  const { notification } = AntApp.useApp();

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    if (!props.multiple && event.dataTransfer.files.length > 1) {
      notification.warning({ title: t("common.warning"), description: t("helpers.draggerValidationCount") });
    } else if (props.accept) {
      const acceptFormat = typeof props.accept === "string" ? props.accept : props.accept.format;
      const supportedTypes = acceptFormat.split(",").map((type) => type.trim());
      const unsupportedFiles = [];

      for (let i = 0; i < event.dataTransfer.files.length; i++) {
        const file = event.dataTransfer.files[i];
        if (
          !supportedTypes.some((supportedType) =>
            supportedType.startsWith(".")
              ? file?.name.endsWith(supportedType)
              : supportedType.endsWith("*")
                ? file?.type.startsWith(supportedType.split("/")[0] ?? "")
                : supportedType === file?.type,
          )
        ) {
          unsupportedFiles.push(file);
        }
      }

      if (unsupportedFiles.length > 0) {
        notification.warning({
          title: t("common.warning"),
          description: (
            <>
              <span>{t("helpers.draggerValidationType")}</span>
              <br />
              <MultiLineText tokens={unsupportedFiles.map((f) => f?.name)} />
            </>
          ),
        });
      }
    }
  };

  return (
    <div className={classNames(styles.uploadDragger, "margin-top-tiny")}>
      <Upload.Dragger {...props} onDrop={handleDrop}>
        <div>
          <AntIcon className={styles.hoverColored} type="upload" style={{ fontSize: 28 }} />

          <div>
            <b className={styles.hoverColored} style={{ fontSize: 18, fontWeight: 600 }}>
              {t(`components.uploadDragger.${props.multiple ? "uploadFiles" : "uploadFile"}`)}
            </b>
          </div>
        </div>

        <AntIcon type="paper-clip" className="margin-right-tiny sub-header-info" />
        <span className="sub-header-info">
          {t(`helpers.draggerHint${props.multiple ? "MultipleFiles" : "OneFile"}`)}
        </span>
      </Upload.Dragger>
    </div>
  );
};
